import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import MainPagetitle from '../../../layouts/MainPagetitle';
import MyComplaintsOverview from '../MyComplaints/MyComplaintsOverview';
import MyComplaintsSearch from '../MyComplaints/MyComplaintsSearch';

const EscalatedComplaints = (props) => {
  const isNodalOfficer = props?.$store?.persona === _enum.ROUTE_PERSONAS.nodal_officer;
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [complaints, setComplaints] = useState([]);
  const [complaintsOverview, setComplaintsOverview] = useState([]);
  const complaintsOverviewCards = [
    'escalatedComplaints',
    'pendingResolutions',
    'resolvedComplaints',
    'awaitingConfirmation',
    'closedComplaints',
  ];
  const [rowcount, setRowcount] = useState(0);
  const [isFetching, setIsFetching] = useState(true);
  const columns = [
    {
      dataIndex: 'complaintId',
      title: 'Complaint ID',
      render: (text, record) => {
        return (
          <>
            <div>
              <h6 className="text-primary fw-bold">{text || '-'}</h6>
            </div>
          </>
        );
      },
    },
    {
      dataIndex: 'customerName',
      title: 'Customer Name',
    },
    {
      dataIndex: 'isExistingCustomer',
      title: 'Customer Type',
      render: (text, record) => {
        return record?.isExistingCustomer ? 'Existing' : 'New';
      },
      display: !isNodalOfficer
    },
    {
      dataIndex: 'assignedComplianceOfficer',
      title: 'Compliance Officer',
      render: (text, record) => {
        return record?.assignedComplianceOfficer?.name || '-';
      },
      display: !isNodalOfficer
    }, 
    {
      dataIndex: 'assignedGrievanceOfficer',
      title: 'Grievance Officer',
      render: (text, record) => {
        return record?.assignedGrievanceOfficer?.name || '-';
      },
      display: isNodalOfficer
    }, 
    {
      dataIndex: 'slaBreachedOn',
      title: 'SLA Breached On',
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.createdAt) {
          return date;
        } else {
          return '-';
        }
      },
    }, 
    {
      dataIndex: 'breachedDuration',
      title: 'Breached Duration'
    },
    {
      dataIndex: 'resolutionStatus',
      title: 'Status',
      render: (text, record) => {
        let mappedStatus = _enum.STATUS_COLOR_MAP[record?.resolutionStatus?.toLowerCase()] || '';
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.resolutionStatus?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: 'customerStatus',
      title: 'Customer Status',
      render: (text, record) => {
        let s = record?.customerStatus?.toLowerCase().split(" ").join("_");
        console.log({s});
        let mappedStatus = _enum.STATUS_COLOR_MAP[s] || '';
        
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.customerStatus?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: 'resolutionDate',
      title: 'Resolution Provided On',
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.resolutionDate) {
          return date;
        } else {
          return '-';
        }
      },
    },
  ];

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 10,
    });
  };

  const view = (record) => {
    let { complaintId } = record;
    let path = `/app/escalatedcomplaintsview?id=${complaintId}&readonly=true`;
    navigate(path);
  };

  const edit = (record) => {
    let { complaintId } = record;
    let path = `/app/escalatedcomplaintsview?id=${complaintId}`;
    navigate(path);
  };

  const onSearch = (data, reset) => {
    let defaultSearchData = Object.only(data, ['limit', 'page']);
    let payload;
    if (reset) {
      payload = {
        ...defaultSearchData,
      };
      getComplaints(payload, reset);
    } else {
      payload = {
        ...data,
        page: 1,
        limit: 10,
      };
      getComplaints(payload, reset);
    }
    setSearch(payload);
  };

  const getComplaintsOverview = () => {
    props.apis.apiGetComplaintCards().then((res) => {
      setComplaintsOverview(res);
    });
  };

  const getComplaints = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ['page', 'limit']);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis.apiGetAllComplaints(payload).then(({ data, total }) => {
      setComplaints(data);
      setRowcount(total);
      setIsFetching(false);
    });
  };

  useEffect(() => {
    getComplaints();
    getComplaintsOverview();
  }, [search]);

  return (
    <>
      <MainPagetitle
        mainTitle="Escalated Complaints"
        pageTitle={'Escalated Complaints'}
        parentTitle={'Home'}
        pageIcon={imagepaths.complaintsIconActive}
      />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-12">
            <MyComplaintsOverview
              title="Complaints Overview"
              cards={complaintsOverviewCards}
              data={complaintsOverview}
              col="col-6 col-md-4 col-lg-3 col-xl-2"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption-container">
                  <h4 className="heading mb-0">Recently Raised Complaints</h4>
                  <div className="d-flex flex-wrap">
                    <MyComplaintsSearch onSearch={(...arg) => onSearch(...arg)} />
                  </div>
                </div>
                <AppTable
                  data={complaints}
                  total={rowcount}
                  onChange={(...arg) => onPageChange(...arg)}
                  columns={columns}
                  reorder={true}
                  viewAction={(...args) => view(...args)}
                  editAction={(...args) => edit(...args)}
                  deletable={false}
                  loading={isFetching}
                  isCustomRowKey={true}
                  customRowKey={'complaintId'}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(EscalatedComplaints);
